import React from 'react';
import styled from 'styled-components';

const ToggleGroup = styled.div`
  display: inline-flex;
  border: 1px solid ${p => p.theme.colors.border};
  border-radius: ${p => p.theme.radius.sm}px;
  overflow: hidden;
`;

const Segment = styled.button`
  padding: 6px 12px;
  min-height: 44px;
  border: none;
  border-right: 1px solid ${p => p.theme.colors.border};
  background: ${p => p.$active
    ? p.theme.colors.gold?.primary || p.theme.colors.bands.exceptional
    : p.theme.colors.surface};
  color: ${p => p.$active
    ? p.theme.colors.surface || '#fff'
    : p.theme.colors.text.secondary};
  font-size: ${p => p.theme.typography.sizes.sm};
  font-weight: ${p => p.$active
    ? p.theme.typography.weights.semibold
    : p.theme.typography.weights.regular};
  cursor: pointer;
  transition: all 0.15s;
  &:last-child { border-right: none; }
  &:hover { opacity: 0.85; }
`;

const SEGMENTS = [
  { value: 'auto',  label: 'Auto' },
  { value: 'light', label: 'Light' },
  { value: 'dark',  label: 'Dark' },
];

const ThemeToggle = ({ mode, onChange }) => (
  <ToggleGroup role="group" aria-label="Theme">
    {SEGMENTS.map(s => (
      <Segment
        key={s.value}
        $active={mode === s.value}
        aria-pressed={mode === s.value}
        onClick={() => onChange(s.value)}
      >
        {s.label}
      </Segment>
    ))}
  </ToggleGroup>
);

export default ThemeToggle;
